import React, { useState } from 'react';
import { CustomParamScenario } from '../api/model';
import CustomEnumComponents from './CustomEnumComponents';
import CustomFieldComponents from './CustomFieldComponents';

const CustomEnumManagement: React.FC = () => {
  const [loading] = useState(false);

  // 场景值与中文展示的映射关系
  const scenarioLabels: Record<CustomParamScenario, string> = {
    [CustomParamScenario.Appointment]: '预约场景',
    [CustomParamScenario.Treatment]: '治疗记录',
    [CustomParamScenario.PatientProfile]: '患者档案',
  };

  return (
    <div>
      <CustomEnumComponents scenarioLabels={scenarioLabels} loading={loading} />
      <CustomFieldComponents scenarioLabels={scenarioLabels} loading={loading} />
    </div>
  );
};

export default CustomEnumManagement;